import { PatientStatus } from "~/common/utils";
import { homePathByPatientStatus, ROUTES } from "../router";

export const getHomePath = (patientStatus?: PatientStatus) => {
  if (!patientStatus) return ROUTES.login;

  return homePathByPatientStatus[patientStatus];
};
